import { useTour } from '@reactour/tour';
import { useEffect, useState } from 'react';

export const useCanvasState = () => {
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [positionPDF, setPositionPDF] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [documentRotation, setDocumentRotation] = useState(0);
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);
  const [isPointerInStage, setIsPointerInStage] = useState(false);
  const [pageHeight, setPageHeight] = useState(0);
  const [pageWidth, setPageWidth] = useState(0);
  const [documentRatio, setDocumentRatio] = useState(1);

  const handleRotate = (rotation: number) => {
    setDocumentRotation((prevRotation) => {
      return prevRotation === -270 || prevRotation === 270
        ? 0
        : prevRotation + rotation;
    });
  };

  const { isOpen, setCurrentStep, currentStep } = useTour();

  useEffect(() => {
    if (isOpen) {
      if (currentStep === 0) {
        handleRotate(180);
      }
    }
  }, [isOpen, setCurrentStep, currentStep]);

  useEffect(() => {
    if (isOpen && documentRotation % 360 === 0 && currentStep === 1) {
      setCurrentStep(2);
    }
  }, [documentRotation, isOpen, setCurrentStep, currentStep]);

  return {
    scale,
    setScale,
    position,
    setPosition,
    positionPDF,
    setPositionPDF,
    offset,
    setOffset,
    documentRotation,
    setDocumentRotation,
    isDocumentLoaded,
    setIsDocumentLoaded,
    isPointerInStage,
    setIsPointerInStage,
    pageHeight,
    setPageHeight,
    pageWidth,
    setPageWidth,
    documentRatio,
    setDocumentRatio,
    handleRotate,
  };
};
